import { FunctionComponent, useCallback } from 'react';

import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

interface ZeroLevelSelectProps {
  onChange: (value: number) => void;
  value: number;
}

const ZeroLevelSelect: FunctionComponent<ZeroLevelSelectProps> = ({ value, onChange }) => {
  const handleChange = useCallback(
    (e: SelectChangeEvent<string>) => onChange(parseFloat(e.target.value.toString())),
    [onChange],
  );

  return (
    <FormControl sx={{ width: 160 }}>
      <InputLabel id="od-select-helper-label">Nullnivå</InputLabel>
      <Select
        labelId="od-select-helper-label"
        value={value.toString()}
        label="Nullnivå"
        onChange={handleChange}
      >
        <MenuItem value="0.59">Sjøkartnull</MenuItem>
        <MenuItem value="0">Normalnull</MenuItem>
      </Select>
    </FormControl>
  );
};

export default ZeroLevelSelect;
